import { render, staticRenderFns } from "./EntryHeaderCard.vue?vue&type=template&id=51a57374&scoped=true&"
import script from "./EntryHeaderCard.vue?vue&type=script&lang=js&"
export * from "./EntryHeaderCard.vue?vue&type=script&lang=js&"
import style0 from "./EntryHeaderCard.vue?vue&type=style&index=0&id=51a57374&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a57374",
  null
  
)

export default component.exports